import { makeAutoObservable } from "mobx";
import { openApi } from "../../../helpers/request";
import { notification } from "antd";
import i from "../../../translations/i";

class PriceTypesController {

  items: any[] = []
  item: any = {
    name: null,
    private_name: ''
  }
  constructor() {
    makeAutoObservable(this)
  }

  add() {
    this.items.push({
      name: '',
    })
  }

  get() {
    openApi('get', `/price_types`)
      .then((result: any) => {
        console.log(result)
       this.items = result.data
      })
      .catch((error: any) => console.log(error.response))
  }

  delete(id: any = null, index: number) {
    this.items.splice(index, 1)

    openApi('delete', `/price_types/${id}`)
      .then((result: any) => {
        this.get()
      })
      .catch((error: any) => console.log(error.response))
  }

  save() {
    const data = new FormData()
    this.items.map((el: any, index: number) => {
      if(el.id && el.id > 0) data.append(`items[${index}][id]`, el.id)
      if(el.name) data.append(`items[${index}][name]`, el.name)
      data.append(`items[${index}][private_name]`, el.private_name)
    })

    openApi('post', '/price_types', data)
      .then((result: any) => {
        console.log(result)
        notification.success({
          message: i.t('def:success.success'),
          description: i.t('def:success.edit')
        })
      })
      .catch((error: any) => {
        console.log(error.response);
        notification.error({
          message: i.t('def:errors.error'),
          description: error.response.data.data.message ?? 'error'
        })
      })
  }

}

export default new PriceTypesController()